import React, {useState} from 'react'
import {IoMdClose,IoIosLogOut} from 'react-icons/io'
import {ImBin} from 'react-icons/im'
export default function LoginSimpleJS() {
  const [page, setPage] = useState('mein')
  const [login, setLogin] = useState(false) 
  const [signup, setSignup] = useState(false)
  const [display, setDisplay] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [list1, setList1] = useState([{id:'1',email:'1@gmail.com',pwd:'1',username:'Jason Larose'},{id:'2',email:'2@gmail.com',pwd:'2',username:'Sheila Murphy'}])
  const [updateList, setUpdateList] = useState()
  const [email, setEmail] = useState()
  const [pwd, setPwd] = useState()
  const [username, setUsername] = useState()
  const [userInput, setUserInput] = useState({})
  const [updateItem, setUpdateItem] = useState()
  const [userErr, setUserErr] = useState(null)
  const onChange2Input=({currentTarget:x})=>{setUserInput({...userInput,[x.name]:x.value})}
  const onClick2Register=()=>{
    setUserErr(null)
    let a=list1.find((x)=>x.email==userInput.email)
    if(a==undefined){
       setList1((x) => [...x,{id: Math.random().toString(),email:userInput.email,pwd:userInput.pwd,username:userInput.username}])
       setSignup(!signup)
       setLogin(!login)
    }else{setUserErr('Your email is already in use. Please use another email.')}
  }
  const onClick2Login=()=>{
    setUserErr(null)
    let a=list1.find((x)=>x.email ==userInput.email)
    if(a!=undefined){
      if(a.pwd ==userInput.pwd){
        setLogin(!login)
        setUserInput(a)
      }else{setUserErr('Your password is not matched.')}
    }else{setUserErr('We could not find any account with this email.')}
  }
  const onClick2SelectPage=(x)=>{setPage(x)} 
  const onClick2Update=(x)=>{
    setUserErr(null)
    let a1=list1.find((x) => x.id ==userInput.id)
    if(a1.email!=userInput.email){
      let a2=list1.find((x)=>x.email ==userInput.email)
      if(a2!=undefined){
        return setUserErr('Your email is already in use. Please use another email.')
      }
    }
    const b1=list1.filter((x)=>x.id===userInput.id)[0]
    const b2=[...list1]
    const i=list1.indexOf(b1)
    b2[i]=userInput
    setList1(b2)
    setPage(x)
  } 
  const onClick2delete2=(dataId)=>{
    setList1((x)=>{return x.filter((x)=>x.id!==dataId)})
    setDisplay(!display)
    setLogin(!login)
  }
  const onClick2delete=(dataId)=>{
    setList1((x)=>{return x.filter((x)=>x.id!==dataId)})
  }
  const onClick2Edit=()=>{
    setUpdateList(list1)
    setEditMode(!editMode)
  }
  const onSubmit2Update=()=>{
    setList1(updateList)
    setEditMode(!editMode)
  } 
  const onChange2Input2=({currentTarget:y},x)=>{
    var b1 = [...updateList]
    var b2 = updateList.filter((w)=>w.id===x)[0]
    var i = updateList.indexOf(b2)
    setUpdateItem({...b2, [y.name]:y.value})
    b1[i] = {...b2, [y.name]:y.value}
    list3(b1)
  }
  const list3=(x)=>{setUpdateList(x)}
  const onClick2Add=(e)=>{
    e.preventDefault()
    setList1((x)=>[...x,{id: Math.floor(Math.random()*1000000000).toString(),email,pwd,username}])
  }
  return(
    <div className='text-center p-1'>
    <div className='text-left w-full md:w-[500px] m-auto mb-1 flex flex-col'>
    {login?<div className='mb-4 flex flex-col'>
    <div className='flex justify-between border-b border-gray-800 mb-4'>My Page<IoIosLogOut className='mt-auto mb-0 duration-300 ease-in-out hover:translate-x-[2px]' onClick={(x)=>setLogin(!login)}/></div>
    {page.slice(0,19)=='Account information'?<>{page.slice(-4)=='edit'?<div className='text-[12px] mb-4'><div className='w-[234px] text-[10px] text-right cursor-default'><div onClick={x=>onClick2Update('Account information')}>Save&Close</div></div>
    <div className='flex'><label className='w-[80px]'>id:</label><div>{userInput.id}</div></div>
    <div className='flex'><label className='w-[80px]'>email:</label><div><input className='border border-gray-800 mb-1' type='email' name='email' defaultValue={userInput.email} onChange={onChange2Input} /></div></div>
    <div className='flex'><label className='w-[80px]'>pwd:</label><div><input className='border border-gray-800 mb-1' type='text' name='pwd' defaultValue={userInput.pwd} onChange={onChange2Input} /></div></div>
    <div className='flex'><label className='w-[80px]'>username:</label><div><input className='border border-gray-800' type='text' name='username' defaultValue={userInput.username} onChange={onChange2Input} /></div></div>
    {userErr!=null?<p className='text-red-700'>{userErr}</p>:''}
    </div>:<div className='text-[12px] mb-4'>
    <div className='w-[200px]'><div className='w-fit mr-0 ml-auto text-[10px] cursor-default' onClick={x=>onClick2SelectPage('Account information edit')}>Edit</div></div>
    <div className='flex'><label className='w-[80px]'>id:</label><div>{userInput.id}</div></div>
    <div className='flex'><label className='w-[80px]'>email:</label><div>{userInput.email}</div></div>
    <div className='flex'><label className='w-[80px]'>pwd:</label><div>{userInput.pwd}</div></div>
    <div className='flex'><label className='w-[80px]'>username:</label><div>{userInput.username}</div></div>
    </div>}
    <u onClick={x=>onClick2SelectPage('mein')} className='cursor-default text-[12px]'>⋅Go back</u>
    </>:<><u onClick={x=>onClick2SelectPage('Account information')} className='cursor-default text-[12px]'>⋅Account information</u></>}<u className='cursor-default text-[12px]' onClick={(x)=>setDisplay(!display)}>⋅Remove your account</u>
    {display ? 
    <div className='modal'>
    <div className='modal-content'>
    <div className='text-right'><button className='plane-btn' onClick={(x)=>setDisplay(!display)}><IoMdClose/></button></div>
    <p className='text-[12px] mb-2'>Do you really remove your account?</p>
    <div className='flex justify-center'><button className='mt-1 border border-gray-800 mt-2 text-[12px] pt-[2px] pb-[2px] pl-[14px] pr-[14px] hover:bg-gray-100' onClick={onClick2delete2.bind(null, userInput.id)}>Remove my account</button></div>
    </div>
    </div>:''}
    </div>:<>{signup?<> Register<br/>
    <label className='text-[12px]'>email</label>
    <input className='p-[4px] rounded-[4px] border border-gray-800' type='email' name='email' defaultValue={userInput.email} onChange={onChange2Input} />
    <label className='text-[12px]'>pwd</label>
    <input className='p-[4px] rounded-[4px] border border-gray-800' type='text' name='pwd' defaultValue={userInput.pwd} onChange={onChange2Input} />
    {userErr!=null?<p className='text-red-700'>{userErr}</p>:''}
    <div className='flex justify-center'><button className='mt-1 border border-gray-800 mt-2 text-[14px] pt-[2px] pb-[2px] pl-[14px] pr-[14px] hover:bg-gray-100 mt-1' onClick={onClick2Register}>Register</button></div>
    <div className='mt-2 flex justify-center mb-4'><button className='text-xs' onClick={(x)=>setSignup(!signup)}><u>Already have an account?</u>
    </button></div>
    </>:<>Login<br/>
    <label className='text-[12px]'>email</label>
    <input className='p-[4px] rounded-[4px] border border-gray-800' type='email' name='email' defaultValue={userInput.email} onChange={onChange2Input} />
    <label className='text-[12px]'>pwd</label>
    <input className='p-[4px] rounded-[4px] border border-gray-800' type='text' name='pwd' defaultValue={userInput.pwd} onChange={onChange2Input} />
    {userErr!=null?<p className='text-red-700'>{userErr}</p>:''}
    <div className='flex justify-center'><button className='mt-1 border border-gray-800 mt-2 text-[14px] pt-[2px] pb-[2px] pl-[14px] pr-[14px] hover:bg-gray-100' onClick={onClick2Login}>Login</button></div>
    <div className='flex justify-center mb-4'><button
    className='mt-2 cursor-default underline text-[12px]'
    onClick={(x)=>setSignup(!signup)}
    >Do not have your account? Register from here.
    </button></div></>}</>} 
    </div>
    <hr/>
    <div className='text-left w-full md:w-[500px] m-auto mb-1 flex flex-col mt-4'>
    <div className='border-b border-gray-800'>Admin Menu</div>
    <div className='mb-2 flex justify-end text-[12px]'>{editMode ? <form onSubmit={onSubmit2Update}><button type='button' onClick={e=>setEditMode(!editMode)} className='mr-2 text-[10px]'>Cancel</button><button className='text-[10px]' type='submit'>Save&Close</button>
    </form>:<><button onClick={onClick2Edit} className='text-[10px]'>Edit</button><button className='pl-1 pr-1' onClick={onClick2Add}>+</button></>}</div>
    {list1.map((x) => (
    <>
    {editMode ? (
    <div className='text-[12px] rounded-[2px] p-1 mb-1 bg-gray-100 flex flex-col'> 
    <div className='flex'><label className='w-[84px] text-[12px]'>id:</label><div>{x.id}</div></div>
    <div className='mb-1 flex w-full'>
    <label className='w-[100px]'>email:</label>
    <input type='email' name='email' className='border border-gray-800 w-full' defaultValue={x.email} onChange={(y)=>onChange2Input2(y, x.id)}/>
    </div>
    <div className='mb-1 flex w-full'>
    <label className='w-[100px]'>pwd:</label>
    <input className='border border-gray-800 w-full' name='pwd' defaultValue={x.pwd} onChange={(y)=>onChange2Input2(y, x.id)}/>
    </div>
    <div className='mb-1 flex w-full'>
    <span className='w-[100px]'>username:</span>
    <input className='border border-gray-800 w-full' name='username' defaultValue={x.username} onChange={(y)=>onChange2Input2(y, x.id)}/>
    </div>
    </div>
    ) : (
    <div className='text-[12px] rounded-[2px] p-1 mb-1 bg-gray-100 flex justify-between' key={x.id}>
    <div>
    <div className='flex'><label className='w-[100px]'>id:</label><div></div>{x.id}</div>
    <div className='flex'><label className='w-[100px]'>email:</label><div>{x.email}</div></div>
    <div className='flex'><label className='w-[100px]'>pwd:</label><div>{x.pwd}</div></div>
    <div className='flex'><label className='w-[100px]'>username:</label><div>{x.username}</div></div>
    </div>
    <div>
    <button onClick={onClick2delete.bind(null, x.id)}><ImBin/></button>
    </div>
    </div>
    )}
    </>
    ))}
    </div> 
  </div>
  )
}